const AFFILIATE_HOSTS = [
    { pattern: /(^|\.)airalo\.com$/i, provider: 'airalo', vertical: 'esim' },
    { pattern: /(^|\.)yesim\.(app|tech)$/i, provider: 'yesim', vertical: 'esim' },
    { pattern: /(^|\.)saily\.com$/i, provider: 'saily', vertical: 'esim' },
    // Трекер Saily — собственный домен go.saily.site, не saily.com: без него 39 ссылок в 28 постах
    // жили голыми <a> без /api/r и без affiliate_click (краул 29.09.2026).
    { pattern: /(^|\.)saily\.site$/i, provider: 'saily', vertical: 'esim' },
    { pattern: /(^|\.)ubigi\.com$/i, provider: 'ubigi', vertical: 'esim' },
    { pattern: /(^|\.)holafly\.com$/i, provider: 'holafly', vertical: 'esim' },
    { pattern: /(^|\.)voyeglobal\.com$/i, provider: 'voye', vertical: 'esim' },
    { pattern: /(^|\.)iroamly\.com$/i, provider: 'iroamly', vertical: 'esim' },
    { pattern: /(^|\.)gomoworld\.com$/i, provider: 'gomoworld', vertical: 'esim' },
    { pattern: /(^|\.)esim4travel\.com$/i, provider: 'esim4travel', vertical: 'esim' },
    { pattern: /(^|\.)drimsim\.com$/i, provider: 'drimsim', vertical: 'esim' },
    // У VPN-партнёрок реферальные домены НЕ совпадают с продуктовыми (.net/.me
    // против .com). Без этих паттернов 18 текстовых ссылок VPN-кластера жили как
    // голые <a>: без /api/r (адблокеры режут go.nordvpn.net по EasyList) и без
    // affiliate_click — отсюда vertical=vpn: 1 клик за 90 дней (аудит 2026-08-13, §7).
    { pattern: /(^|\.)nordvpn\.(com|net)$/i, provider: 'nordvpn', vertical: 'vpn' },
    { pattern: /(^|\.)surfshark\.(com|net)$/i, provider: 'surfshark', vertical: 'vpn' },
    { pattern: /(^|\.)protonvpn\.com$/i, provider: 'protonvpn', vertical: 'vpn' },
    { pattern: /(^|\.)getproton\.me$/i, provider: 'protonvpn', vertical: 'vpn' },
    { pattern: /(^|\.)tripster\.(com|ru)$/i, provider: 'tripster', vertical: 'tours' },
    { pattern: /(^|\.)viator\.com$/i, provider: 'viator', vertical: 'tours' },
    { pattern: /(^|\.)getyourguide\./i, provider: 'gyg', vertical: 'tours' },
    { pattern: /(^|\.)gyg\.me$/i, provider: 'gyg', vertical: 'tours' },
    { pattern: /(^|\.)kiwitaxi\.(com|ru)$/i, provider: 'kiwitaxi', vertical: 'transport' },
    { pattern: /(^|\.)welcomepickups\.com$/i, provider: 'welcomepickups', vertical: 'transport' },
    { pattern: /(^|\.)localrent\.com$/i, provider: 'localrent', vertical: 'transport' },
    { pattern: /(^|\.)economybookings\.com$/i, provider: 'economybookings', vertical: 'transport' },
    { pattern: /(^|\.)discovercars\.com$/i, provider: 'discovercars', vertical: 'transport' },
    { pattern: /(^|\.)bikesbooking\.com$/i, provider: 'bikesbooking', vertical: 'transport' },
    { pattern: /(^|\.)searadar\.com$/i, provider: 'searadar', vertical: 'transport' },
    { pattern: /(^|\.)omio\.(com|ru)$/i, provider: 'omio', vertical: 'transport' },
    // 12Go — билеты на поезда/автобусы Georgian Railways и ЮВА. Заявка в TP подана
    // 2026-08-13, паттерн добавлен заранее: как только ссылки появятся в статьях,
    // они сразу получат /api/r-обёртку и трекинг (см. memory 12go-activation-runbook).
    { pattern: /(^|\.)12go\.(asia|co)$/i, provider: '12go', vertical: 'transfer' },
    // Aviasales подключён в TP (метка 633678), но домена здесь не было: короткие
    // aviasales.tpo.li и прямые ссылки уходили в GA4 как affiliate_network/unknown,
    // и авиа-вертикаль в отчётах не существовала (AFFILIATE_NETWORKS_2026-09-29).
    { pattern: /(^|\.)aviasales\.(ru|com)$/i, provider: 'aviasales', vertical: 'flights' },
    { pattern: /(^|\.)booking\.com$/i, provider: 'booking', vertical: 'stay' },
    { pattern: /(^|\.)trip\.com$/i, provider: 'trip', vertical: 'stay' },
    { pattern: /(^|\.)ekta/i, provider: 'ekta', vertical: 'insurance' },
    { pattern: /(^|\.)cherehapa\.ru$/i, provider: 'cherehapa', vertical: 'insurance' },
];

const TRACKER_HOST_PATTERN = /(^|\.)(?:tp\.st|tpo\.li|sjv\.io|pxf\.io|tp\.media|travelpayouts\.com)$/i;

export function unwrapAffiliateTarget(href) {
    if (typeof href !== 'string' || !href) return href;
    try {
        const parsed = new URL(href, 'https://www.triplinkhub.com');
        if (parsed.pathname === '/api/r') {
            return parsed.searchParams.get('u') || href;
        }
    } catch { }
    return href;
}

export function getAffiliateMetadata(href) {
    const target = unwrapAffiliateTarget(href);
    if (typeof target !== 'string' || !target) return null;

    let parsed;
    try {
        parsed = new URL(target);
    } catch {
        return null;
    }

    const host = parsed.hostname.toLowerCase();
    const known = AFFILIATE_HOSTS.find(({ pattern }) => pattern.test(host));
    if (known) return { provider: known.provider, vertical: known.vertical, destinationHost: host };

    if (TRACKER_HOST_PATTERN.test(host)) {
        const nestedTarget = parsed.searchParams.get('u');
        const nested = nestedTarget ? getAffiliateMetadata(nestedTarget) : null;
        if (nested) return nested;
        // Короткие ссылки Travelpayouts называются по бренду: `discovercars.tpo.li`,
        // `economybookings.tpo.li`, `ektatraveling.tpo.li`. Вложенного `u` у них нет, и без
        // этой ветки весь клик уходил в GA4 как provider=affiliate_network, vertical=unknown —
        // то есть вертикаль, дающая 76% денег, в отчётах не отличалась от eSIM (найдено 18.09).
        const label = host.split('.')[0];
        const byLabel = label && AFFILIATE_HOSTS.find(({ pattern }) => pattern.test(`${label}.com`));
        if (byLabel) return { provider: byLabel.provider, vertical: byLabel.vertical, destinationHost: host };
        return { provider: 'affiliate_network', vertical: 'unknown', destinationHost: host };
    }

    return null;
}

export function isAffiliateUrl(href) {
    return Boolean(getAffiliateMetadata(href));
}

function safePart(value, fallback) {
    const normalized = String(value || '')
        .toLowerCase()
        .trim()
        .replace(/^\/+|\/+$/g, '')
        .replace(/[^a-z0-9_-]+/g, '-')
        .replace(/-{2,}/g, '-')
        .replace(/^-|-$/g, '');
    return normalized || fallback;
}

export function buildAffiliateSubId({ language, pageSlug, position, variant } = {}) {
    const parts = [
        safePart(language, 'xx'),
        safePart(pageSlug, 'unknown-page'),
        safePart(position, 'unknown-position'),
    ];
    if (variant) parts.push(safePart(variant, 'control'));
    return parts.join('.').slice(0, 120);
}
